<app-content-header [stepsBack]="1"
  [headline]="'phonenumber_selected_numbers' | i18next: {selected: selectedPhonenumbers.size, max: maxAllowedAcquiredNumbers}">
</app-content-header>

<div class="row align-items-stretch mt-2">
  @for (b of blocks; track b) {
    <app-select-phonenumber-card
      (toggle)="onPhonenumberBlockToggled($event)"
      [isSelected]="selectedPhonenumbers.has(b.blockId)"
      [blockOffer]="b"  class="col-xs-12 col-xl-4 mb-3">
    </app-select-phonenumber-card>
  }

</div>

<div class="d-flex justify-content-end">
  <div class="p-3">
    <button class="btn btn-outline-primary" [disabled]="selectedPhonenumbers.size === 0" (click)="select()">{{'app_next' | i18next}}</button>
  </div>
</div>
